import { type MarketplaceBuyAsset, type MarketplaceCollection } from '@pkg/types';

import { CollectionChainType } from '@app/client';

// Is this the `collection address`?
// 0xeB54FAECe42cC85676DAe7855b30347fDce1DC4C
const collection: MarketplaceCollection = {
    chain: CollectionChainType.Ethereum,
    contractAddress: '0x0f23927b0466be6531e8dc84f047d34209a88e41',
    name: 'realsteamboatwillie',
};

const asset1: MarketplaceBuyAsset = {
    orders: [],
    id: '1243',
    description: '',
    collection,
    tokenId: '1049',
    name: 'Mickey #1049',
    imageUrl: 'https://i.seadn.io/s/raw/files/d0c336e25de04b9769d5334fa5850ca5.png',
    price: {
        currency: 'eth',
        value: '0.248',
    },
};

const asset2: MarketplaceBuyAsset = {
    orders: [],
    id: '1246',
    description: '',
    collection,
    tokenId: '1032',
    name: 'Mickey #1032',
    imageUrl: 'https://i.seadn.io/s/raw/files/ddcf9ab14bceadbb1288d2a175f70355.png',
    price: {
        currency: 'eth',
        value: '0.2814',
    },
};

const asset3: MarketplaceBuyAsset = {
    orders: [],
    id: '12400',
    description: '',
    collection,
    tokenId: '479',
    name: 'Mickey #479',
    imageUrl: 'https://i.seadn.io/s/raw/files/717cb3d45b0ab3e58a47fd2cb697d169.png',
    price: {
        currency: 'eth',
        value: '0.295',
    },
};

const asset4: MarketplaceBuyAsset = {
    orders: [],
    id: '1240',
    description: '',

    collection,
    tokenId: '1727',
    name: 'Mickey #1727',
    imageUrl: 'https://i.seadn.io/s/raw/files/b803c40ff9c5cc4e2a7c15d3ca86c04d.png',
    price: {
        currency: 'eth',
        value: '0.3',
    },
};

export const mock = {
    cart: [asset1, asset2, asset3, asset4],
};
